import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "onOpenChange", "portal", "size", "preventOutside", "preventEscape", "header", "body", "children", "footer", "hideCloseButton", "closeButtonProps"],
  _excluded2 = ["onEscapeKeyDown", "onInteractOutside"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useCallbackPrevention } from '../../internal/hooks/usePreventedEventCallback';
import { ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalRoot } from './Modal';
import { composeEventHandlers } from '../../../internal/utils/composeEventHandlers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Предсозданный из примитивов компонент модального окна Modal
 */
export var Modal = /*#__PURE__*/React.memo(function Modal(_ref) {
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    _ref$portal = _ref.portal,
    portal = _ref$portal === void 0 ? true : _ref$portal,
    size = _ref.size,
    preventOutside = _ref.preventOutside,
    preventEscape = _ref.preventEscape,
    header = _ref.header,
    body = _ref.body,
    children = _ref.children,
    footer = _ref.footer,
    hideCloseButton = _ref.hideCloseButton,
    closeButtonProps = _ref.closeButtonProps,
    contentProps = _objectWithoutProperties(_ref, _excluded);
  var onEscapeKeyDown = contentProps.onEscapeKeyDown,
    onInteractOutside = contentProps.onInteractOutside,
    restContentProps = _objectWithoutProperties(contentProps, _excluded2);
  var preventCloseByEscape = useCallbackPrevention(preventEscape);
  var preventCloseByOutsideInteraction = useCallbackPrevention(preventOutside);
  var handleOnEscapeKeyDown = React.useMemo(function () {
    return composeEventHandlers(preventCloseByEscape, onEscapeKeyDown);
  }, [onEscapeKeyDown, preventCloseByEscape]);
  var handleOnInteractOutside = React.useMemo(function () {
    return composeEventHandlers(preventCloseByOutsideInteraction, onInteractOutside);
  }, [onInteractOutside, preventCloseByOutsideInteraction]);
  return /*#__PURE__*/_jsx(ModalRoot, {
    onOpenChange: onOpenChange,
    open: open,
    modal: portal,
    children: /*#__PURE__*/_jsxs(ModalContent, _objectSpread(_objectSpread({
      size: size,
      overlay: preventOutside ? 'blured' : undefined,
      onEscapeKeyDown: handleOnEscapeKeyDown,
      onInteractOutside: handleOnInteractOutside
    }, restContentProps), {}, {
      children: [!hideCloseButton && /*#__PURE__*/_jsx(ModalCloseButton, _objectSpread({
        theme: "fill_dark",
        size: "XS",
        icon: /*#__PURE__*/_jsx(IconActionClose16, {
          color: "current_color"
        }),
        title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
      }, closeButtonProps)), header && /*#__PURE__*/_jsx(ModalHeader, {
        children: header
      }), children || /*#__PURE__*/_jsx(ModalBody, {
        children: body
      }), footer && /*#__PURE__*/_jsx(ModalFooter, {
        children: footer
      })]
    }))
  });
});